import { GlobalsPrototype, createGlobalsFromJsonScript } from '../../../global/js/globals-prototype.js';

window.GlobalsPrototype = GlobalsPrototype;
window.GLOBALS = createGlobalsFromJsonScript();
